module.exports = __webpack_public_path__ + "img/step3_jd.e00ae017.png";